import { selectPromoInventory } from './selectPromoInventory';
import { IApplicationState } from '../../types/redux';

export function selectNewbuildingsForPromoInventoryStatus(state: IApplicationState) {
  const promoInventory = selectPromoInventory(state);

  return promoInventory.fetchingStatus;
}
